import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '../pages/Index'
import News from '../pages/News'
import NewsMore from '../pages/NewsMore'
import OpenLive from '../pages/OpenLive'
import OpenedLive from '../pages/OpenedLive'
import uploadLive from '../pages/uploadLive'
import aboutUs from '../pages/aboutUs'
import contact from '../pages/contact'
import introduce from '../pages/introduce'
import introduce3 from '../pages/introduce3'
import introduce2 from '../pages/introduce2'
import NewsDetail from '../pages/NewsDetail'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/NewsMore',
      name: 'NewsMore',
      component: NewsMore
    },
    {
      path: '/OpenLive',
      name: 'OpenLive',
      component: OpenLive
    },
    {
      path: '/OpenedLive',
      name: 'OpenedLive',
      component: OpenedLive
    },
    {
      path: '/uploadLive',
      name: 'uploadLive',
      component: uploadLive
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce
    },
    {
      path: '/introduce3',
      name: 'introduce3',
      component: introduce3
    },
    {
      path: '/introduce2',
      name: 'introduce2',
      component: introduce2
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/NewsDetail',
      name: 'NewsDetail',
      component: NewsDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js